import React from "react";
import Modal from "../../components/atoms/Modal";
import BtnModal from "../../components/atoms/BtnModal";
import toast from "react-hot-toast";

const JsonModal = ({showModal, closeModal,data}) => {
    const json = {};

    if (data!==null){
        if (data.testType === "کیفیت سنج") {
            json["IAQ_Index"] = 2;
            data.sensore.forEach((s) => {
                json[`${s.jsonname}_Index`] = 2;
            });
        }

        data.sensore.forEach((s) => {
            json[`${s.jsonname}_Value`] = 2;
        });

    }


    const copyJson = () => {
        const jsonText = JSON.stringify(json, null, 2);
        navigator.clipboard.writeText(jsonText);
        toast.success("متن کپی شد", {
            className: "text-12 text-dark-blue-200",
        });
    };
    return (
        <>
            {showModal ? (
                <>
                    <Modal title={"فایل نمونه JSON  این مدل"} closeModal={closeModal}>
                        <div
                            className="bg-gray-chart-200 w-336 h-350 px-3.5 py-5.5 overflow-y-scroll"
                            dir="ltr">
              <pre className="block whitespace-pre-wrap ">
                {JSON.stringify(json, null, 2)}
                </pre>
                        </div>
                        {/*footer*/}
                        <div className="flex items-center justify-end pt-5.5">
                            <BtnModal text={"کپی کردن متن"} accept={copyJson}/>
                        </div>
                    </Modal>
                </>
            ) : null}
        </>
    );
};

export default JsonModal;
